<!-- 招贤纳士 -->
<template>
    <div class="invite_c">
      <sub-banner id="id_about">
        <img src="../../assets/images/corporateCulture/recruit.jpg"/>
      </sub-banner>
      <div class="invite_content">
         <div class="company_introd_info">
          <div class="company_introd_detail">
            <div class="title">
                {{$t('NavabarText.navbr_child_join_1')}}</div>
            <div class="detail_content">
              <div class="item_c">
                <div class="item_c_img">
                  <img src="../../assets/images/aboutUs/about_two.png"/>
                </div>
              </div>
              <div class="item_c">
                <div class="item_c_text">
                  <!-- <div class="t_content">
                    {{$t('concept.item_1')}}
                  </div> -->
                  <div class="t_content">
                    
                    {{$t('concept.item_1')}}
                  </div>
                  <div class="t_content">
                    
                    {{$t('concept.item_2')}}
                  </div>
                  <div class="t_content">
                    
                    {{$t('concept.item_3')}}
                  </div>
                  
                  <div class="t_content">
                    
                    {{$t('concept.item_4')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="title">  {{$t('NavabarText.navbr_child_join_3')}}</div>
             <div class="detail_content">
              <div class="item_c">
                <div class="item_c_text">
                  <div class="t_content">
                   
                    {{$t('concept.item_5')}}
                  </div>

                  <div class="t_content">
                    
                    {{$t('concept.item_6')}}
                  </div>
                </div>
              </div>
              <div class="item_c">
                <div class="item_c_img">
                  <img src="../../assets/images/aboutUs/about_one.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="personnel_content">
            <div class="personnel_info">
                <div class="title">   {{$t('NavabarText.navbr_child_join_2')}}</div>
                <div class="personnel_recruit">
                    <div class="person_item">
                        <div class="person_item_title">医疗器械工程师</div>
                        <div class="person_item_desc">
                            1.负责产品的现场安装调试及相关技术问题的解决；<br/>
                            2.负责区域内产品的保养、维修，对客户的巡防和服务；<br/>
                            3.为客户提供远程及现场的技术支持及培训；<br/>
                            4.跟踪设备的运行状况，及时了解接收客户反馈信息；<br/>
                            5.能适应出差。<br/>

                        </div>
                    </div>
                   
                    <div class="person_item">
                        <div class="person_item_title">医疗器械商务专员</div>
                        <div class="person_item_desc">
                            1.公司商务信息的整理、分类，对项目进行时时跟踪；<br/>
                            2.收集并对往来商务信函、传真、邮件存档备查；<br/>
                            3.负责商务合同的履行，及时协调和协助解决出现的商务问题；<br/>
                            4.负责商务合同的处理、整理、归类；<br/>
                            5.各类商务活动的接洽，以及客户接待的负责。<br/>

                        </div>
                    </div>
                    <div class="person_item">
                        <div class="person_item_title">医疗器械销售专员(阳江)</div>
                        <div class="person_item_desc">
                            1.在团队主管的领导下完成销售目标，负责公司产品的推广及介绍，必要时进行手术的跟台工作；<br/>
                            2.定期拜访客户及代理商，维护客情，了解客户需求变化；<br/>
                            3.掌握所辖区域内客户进、销、存情况，及时跟进客户提货计划；<br/>
                            4.负责市场信息的收集与调研工作，加深行业了解。<br/>

                        </div>
                    </div>
                </div>
                 <div class="personnel_recruit">
                    
                    <div class="person_item">
                        <div class="person_item_title">医疗器械区域销售经理</div>
                        <div class="person_item_desc">
                            1.负责所辖区域的产品推广销售任务；<br/>
                            2.负责销售区域内销售活动的策划和执行，完成销售指标；<br/>
                            3.开拓新市场，发展新客户，扩大产品销售范围；<br/>
                            4.维护已有客户关系，保持良好互动；<br/>
                            5.负责收集市场和行业信息，加深行业了解。<br/>

                        </div>
                    </div>
                    <div class="person_item">
                        <div class="person_item_title">行政专员</div>
                        <div class="person_item_desc">
                            1.负责公司日常行政监督和支持职能；<br/>
                            2.负责固定资产、行政采购以及物资管理并做好出入库台账等；<br/>
                            3.负责日常考勤统计，行政费用申请；<br/>
                            4.负责办公室的环境维护，保证设备安全及正常运转；<br/>
                            5.协助公司员工活动的组织、各种会务工作的支持。<br/>

                        </div>
                    </div>
                     <div class="person_item">
                        <div class="person_item_title">医疗器械仓管</div>
                        <div class="person_item_desc">
                            1.公司仓库各类产品管理；<br/>
                            2.进销存记录；<br/>
                            3.订单收录排期发货；<br/>
                            4.定期盘点库存；<br/>
                            5.库存数据定期更新。<br/>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="concat_form">
            <div class="form_content">
                <div class="title">{{$t('NavabarText.join_us')}}</div>
                <div class="form_item">
                    <div class="form_item_name">{{$t('postData.name')}}</div>
                    <div class="form_item_input">
                        <el-input :placeholder="$t('postData.name_placeholder')" v-model="concat.name"></el-input>
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_item_name">{{$t('postData.phone')}}</div>
                    <div class="form_item_input">
                        <el-input :placeholder="$t('postData.phone_placeholder')" v-model="concat.phone"></el-input>
                    </div>
                </div>
                
                <div class="form_item">
                    <div class="form_item_name">{{$t('postData.post')}}</div>
                    <div class="form_item_input">
                        <el-select :placeholder="$t('postData.post_placeholder')" v-model="concat.postName">
                            <el-option
                                v-for="item in postList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="submit_content">
                    <div class="submit_form_info">
                        <div class="submit_form" @click="submitClick()">
                            <div class="des_name">{{$t('postData.submit')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


      </div>
    </div>

</template>

<script>
// import { concatMeta } from '@/config/metaJson.js'
import SubBanner from "@/components/sub-banner";
import {addJoinUs} from '../../service/service'
export default {
  name: 'concept',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-招贤纳士',
      metaName:'广州市熵达贸易有限公司-招贤纳士',
      metaContent:'广州市熵达贸易有限公司-招贤纳士',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司' ,   
      concat:{
          name:'',
          phone:'',
          postName:'',
      },
      postList:[
          {value:'销售专员',label:'销售专员'},
          {value:'运营经理',label:'运营经理'},
          {value:'仓管员',label:'仓管员'},
          {value:'财务出纳',label:'财务出纳'},
          {value:'销售经理',label:'销售经理'},
      ]
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
     submitClick(){
        if(!this.judgeIsEmpty(this.concat.name)){
           alert('姓名不能为空！');
           return ;
         }
        if(!this.judgeIsEmpty(this.concat.phone)){
           alert('联系方式不能为空！');
           return ;
        } 
        if(!this.judgeIsEmpty(this.concat.postName)){
           alert('应聘岗位不能为空！');
           return ;
        }
        this.addJoinUs();

     },
     judgeIsEmpty(val){
         if(val==''||val==undefined||val==null){
             return false;
         }else{
             return true;
         }
     },
     async addJoinUs(){
         let resp=await addJoinUs(this.concat);
         if(resp&&resp>0){
             alert("提交成功,稍后我们将会联系您！");
             
         }else{
             alert("提交失败,错误："+resp.userTip)
         }
     }
  },
  created () {

  },
  mounted () {
  },
}
</script>
<style lang='scss' scoped>

.invite_c{
    .invite_content{
        width:100%;
        background:#ffffff;
        // .concept_info{
        //     width:70%;
        //     margin: auto;
        //     .info_title{
        //         margin-top:119px;
        //         font-size:40px;
        //         font-weight: bold;
        //         color:#4f7cbd;
        //     }  
        // }
     .company_introd_info{
        width:70%;
        margin:auto;
        
        .company_introd_detail{
          padding:102px 0px;
          .title{
            color:#4f7cbd;
            font-size: 40px;
            font-weight: bold;
            margin-bottom: 71px;
          }
          .detail_content{
            display: flex;
            align-items: center;
            justify-content: center;
            .item_c{
              padding-bottom:73px;
              padding-left:130px;
              .item_c_img{
                width: 580px;
                // height: 320px;
                img{
                  width:100%;
                  height: 100%;
                }
              }
              .item_c_text{
                text-align: left;
                width: 580px;
                .t_title{
                  font-size: 21px;
                  font-weight: bold;
                  color:#333333;
                  margin-bottom: 27px;
                }
                .t_content{
                  
                  font-size: 21px;

                  line-height: 40px;
                  color:#333333;
                  text-indent:24px;
                }
              }
              
            }
          }
        }
      }


      .personnel_content{
        background:#f8fbff;
       
        padding-top:87px;
        padding-bottom:100px;
        .personnel_info{
            width:70%;
            margin: auto;
            .title{
                color:#4f7cbd;
                font-size: 40px;
                font-weight: bold;
                margin-bottom: 73px;
            }
            .personnel_recruit{
                display: flex;
                align-items: center;
                justify-content: center;
                // flex-wrap: wrap;
                flex-direction: row;
                .person_item{
                    padding:30px 36px 33px 39px;
	                background-color: #ffffff;
                    max-width: 387px;
                    margin-left:20px;
                    margin-bottom: 20px;
                    text-align: left;
                    .person_item_title{
                        position: relative;
                        font-size: 26px;
                        letter-spacing: 2px;
                        color: #333333;
                        font-weight: bold;
                        margin-bottom: 20px;
                    }
                    .person_item_desc{
                        margin-top:15px;
                        font-size: 18px;
                        letter-spacing: 1px;
                        color: #999999;
                        height: 250px;
                        width:340px;
                        line-height: 29px;
                    }
                    &:first-child{
                        margin-left: 0px !important;
                    }
                    .person_item_title:after{
                        content:" ";
                        position:absolute;
                        left:0;
                        bottom:-5px;
                        width:100%;
                        height:1px;
                        transform:scaleY(.8);
                        background-color:#eeeeee;
                    }
                }
            }
        }
      }

      .concat_form{
          width:100%;
          background: #ffffff;
          .form_content{
              width:70%;
              margin:auto;
              padding-top:100px;
              padding-bottom:115px;
              .title{
                    color:#4f7cbd;
                    font-size: 40px;
                    font-weight: bold;
                    margin-bottom: 71px;
              }
              .form_item{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    height: 60px;
                    background-color: #ffffff;
                    border: solid 1px #dddddd;
                    margin-bottom:20px;
                    text-align: left;
                  .form_item_name{
                      margin-left:42px;
                      font-size: 18px;
                      letter-spacing: 1px;
                      color: #333333;
                      width:120px;
                  }
                  .form_item_input{
                      margin-left:25px;
                      width:90%;
                  }
              }

              
            .submit_content{
                margin-top:54px;
                .submit_form_info{
                    display: flex;
                    justify-content: center;
                    .submit_form{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width:160px;
                        height: 52px;
                        // padding:15px 30px;
                        background-color: #4f7cbd;
                        border-radius: 26px;
                        font-size: 24px;
                        color:#ffffff;
                        cursor: pointer;
                        .des_name{

                        }
                        .des_name:hover{
                            color:#009fe9 ;
                        }
                    }
                    
                }
                
            }
          }
      }


    }
}



</style>






// WEBPACK FOOTER //
// src/view/invite/concept.vue